import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const IssuePagination = (props) => {
    const currentPage = props.currentPage;
    const lastPage = props.lastPage;
    const changePage = props.changePage;
    const nextPage = props.nextPage;
    const prevPage = props.prevPage;

    const getPage = (number, active = false) => {
        if (number > 0) {
            return (
                <PaginationItem active={active}>
                    <PaginationLink
                        onClick={() => {
                            changePage(number);
                        }}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            );
        }
    };

    if (nextPage || prevPage) {
        return (
            <Pagination listClassName="justify-content-center">
                {/**
                * Navigate to first page button
                */}
                <PaginationItem>
                    <PaginationLink
                        first
                        onClick={() => {
                            changePage(1);
                        }}
                    />
                </PaginationItem>
                {/**
                * Navigate to previous page button
                */}
                <PaginationItem>
                    <PaginationLink
                        previous
                        onClick={() => {
                            changePage(currentPage - 1);
                        }}
                    />
                </PaginationItem>

                {/**
                * Page before the active one. If it's the first page,
                * then this isn't rendered so the user will see only 2 button options.
                */}
                {getPage(currentPage - 1)}

                {/**
                * Current page
                */}
                {getPage(currentPage, true)}

                {/**
                * Page after the current page. If it's the last page,
                * then this isn't rendered so the user will see only 2 button options.
                */}
                {nextPage ? getPage(currentPage + 1) : null}

                {/**
                * Navigate to next page button
                */}
                <PaginationItem>
                    <PaginationLink
                        next
                        onClick={() => {
                            changePage(currentPage + 1);
                        }}
                    />
                </PaginationItem>
                {/**
                * Navigate to last page button
                */}
                <PaginationItem>
                    <PaginationLink
                        last
                        onClick={() => {
                            changePage(lastPage);
                        }}
                    />
                </PaginationItem>
            </Pagination>
        );
    }
    return null;
};

export default IssuePagination;
